import React from 'react'
import { CustomFloatingFilterDisplayProps } from 'ag-grid-react'
import DimensionTreeCheckboxFilter from '../../../../../features/dimension/components/DimensionTreeCheckboxFilter'

/**
 * Custom floating filter component for dimension selection using tree checkboxes
 */
const DimensionColumnFilter: React.FC<CustomFloatingFilterDisplayProps> = ({ model, onModelChange }) => {
  const selectedValues: string[] = model?.values || []

  const handleChange = (dimensionIds: string[]) => {
    if (dimensionIds.length === 0) {
      onModelChange(null)
    } else {
      onModelChange({ filterType: 'set', values: dimensionIds })
    }
  }

  return (
    <div style={{ width: 400, padding: '4px' }}>
      <DimensionTreeCheckboxFilter value={selectedValues} onChange={handleChange} checkOnSearch />
    </div>
  )
}

export default DimensionColumnFilter
